define('lq/cordovaPushNotifications',[
    'underscore',
    'lq/main',
    'lq/dispatcher'
], function(_, main, dispatcher) {
    'use strict';

    var currentRegistrationDeviceIdKey = 'notifications.device_id';
    var currentRegistrationUserIdKey = 'notifications.user_id';
        
    var notifications = undefined;

    return {

        get: function (userId) {

            if (!notifications) {
                var listeners = [];
                var receivedNotifications = [];

                var push = window.PushNotification.init({
                    'android': {
                        icon: 'notification_icon',
                        iconColor: '#00C07C'
                    },
                    'ios': {
                        "alert": true,
                        "badge": true,
                        "clearBadge": 'true'
                    },
                    'windows': {}
                });

                push.on('registration', function (data) {
                    var registeredDeviceId = localStorage.getItem(currentRegistrationDeviceIdKey);
                    var registeredUserId = localStorage.getItem(currentRegistrationUserIdKey);

                    if (registeredDeviceId !== data.registrationId || registeredUserId !== userId) {
                        dispatcher.dispatch('LicquidAction/RegisterMobileDevice',
                            {
                                deviceId: data.registrationId,
                                previousDeviceId: registeredDeviceId,
                                messenger: data.registrationType.toLowerCase(),
                                platform: device.platform.toLowerCase()
                            })
                            .done(function () {
                                localStorage.setItem(currentRegistrationDeviceIdKey, data.registrationId);
                                localStorage.setItem(currentRegistrationUserIdKey, userId);
                            }, $.noop);
                    }
                });

                push.on('notification', function (data) {
                    var message = data.additionalData;

                    receivedNotifications.push(message);

                    _.each(listeners, function (listener) {
                        listener(message);
                    });
                });

                notifications = {

                    hasReceivedNotifications: function () {
                        return receivedNotifications.length > 0;
                    },

                    getAllReceivedNotifications: function () {
                        return receivedNotifications;
                    },

                    addListener: function (callback) {
                        listeners.push(callback);
                    }

                };

            }

            return notifications;
        }

    }
});
